import HolidayDisplay from './HolidayDisplay';

export default HolidayDisplay;
